module.exports = __webpack_public_path__ + "img/ic_download.aedd21e7.svg";